import * as React from 'react'

import { Route, Redirect, RouteProps } from 'react-router-dom'

import { useAuth } from '../../contexts/Authentication'

const GuestOnlyRoute: React.FC<RouteProps> = ({ children, ...props }) => {
  const { state } = useAuth()

  return (
    <Route
      {...props}
      render={() => {
        return !state.auth.key ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        )
      }}
    />
  )
}

export default GuestOnlyRoute
